import React from "react"
import type { ReactNode } from "react"

export function jsxTextContent(children: ReactNode): string {
  if (!children) return ""
  return (
    React.Children.map(children, child => {
      if (typeof child === "string") return child
      if (React.isValidElement(child) && child.props.children)
        return jsxTextContent(child.props.children)
      return ""
    }) || []
  ).join("")
}
